import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Brain, LayoutTemplate } from 'lucide-react';
export const ValueProps: React.FC = () => {
  const cards = [{
    icon: <Shield className="w-8 h-8 md:w-10 md:h-10 text-gold-500" data-id="element-152" />,
    title: 'MÁS SEGURIDAD EN SESIÓN',
    desc: 'Entrás a cada encuentro con claridad. Sabés qué trabajar, cómo avanzar y cómo cerrar.'
  }, {
    icon: <Brain className="w-8 h-8 md:w-10 md:h-10 text-gold-500" data-id="element-153" />,
    title: 'MÁS CALMA PROFESIONAL',
    desc: 'Menos ansiedad antes de atender. Menos sensación de "a ver qué surge hoy".'
  }, {
    icon: <LayoutTemplate className="w-8 h-8 md:w-10 md:h-10 text-gold-500" data-id="element-154" />,
    title: 'ESTRUCTURA REAL',
    desc: 'No es teoría universitaria. Son herramientas clínicas prácticas listas para usar desde la próxima sesión.'
  }];
  return <section className="py-12 md:py-20 bg-navy-800 px-4" data-id="element-155">
      <div className="max-w-md md:max-w-5xl mx-auto text-center" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-14" data-id="element-157">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4" data-id="element-158">
            UN SISTEMA QUE TE ORDENA{' '}
            <span className="text-gold-500" data-id="element-159">(Y TE DA SEGURIDAD)</span>
          </h2>
          <p className="text-base md:text-xl text-gray-300 md:max-w-3xl md:mx-auto" data-id="element-160">
            <strong className="text-white" data-id="element-161">
              KIT Sesiones Clínicas™ (Sistema Práctico)
            </strong>
            <br data-id="element-162" />
            Creamos un sistema claro y aplicable para que dejes de depender del
            momento, de la intuición sola o del cansancio mental… y empieces a
            trabajar con estructura profesional.
          </p>
        </motion.div>

        <div className="space-y-4 md:space-y-0 md:grid md:grid-cols-3 md:gap-8" data-id="element-163">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-navy-700 p-5 md:p-8 rounded-xl md:rounded-2xl border border-navy-600 text-center md:text-left" data-id="element-164">
              <div className="bg-navy-900 w-12 h-12 md:w-16 md:h-16 rounded-lg md:rounded-xl flex items-center justify-center mx-auto md:mx-0 mb-4 md:mb-6 border border-navy-600" data-id="element-165">
                {card.icon}
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-white" data-id="element-166">
                {card.title}
              </h3>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-167">
                {card.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};